import { KnowledgeArticle, createArticle } from '../types'

export const controlsArticles: KnowledgeArticle[] = [
  createArticle({
    id: 'understanding-controls',
    title: 'Understanding Controls',
    section: 'controls',
    summary: 'Controls are security requirements from compliance frameworks like PCI DSS, SOC 2, HIPAA. Each control has a status, owner, evidence, and review frequency.',
    content: `
# Understanding Controls

Controls are the backbone of your compliance program. Each control represents a security or operational requirement from a compliance framework.

## Control Status

Controls have the following statuses:
- **Not Started** - No work has been done on this control
- **In Progress** - Currently being implemented
- **Implemented** - Control is fully operational
- **Not Applicable** - Control doesn't apply to your organization

## Control Properties

Each control has:
- **Title** - Name of the control requirement
- **Description** - Detailed explanation of what's required
- **Framework** - Which compliance framework it belongs to
- **Owner** - Person responsible for the control
- **Evidence** - Documents proving compliance
- **Review Frequency** - How often the control should be reviewed

## Managing Controls

1. Click on a control to view its details
2. Update the status as you make progress
3. Assign an owner to be responsible
4. Upload evidence to prove compliance
5. Link related policies and procedures

## Bulk Operations

You can perform bulk operations on controls:
- Select multiple controls using checkboxes
- Mark as Not Applicable for controls that don't apply
- Assign owners in bulk
- Update status for multiple controls
    `.trim(),
    tags: ['controls', 'compliance', 'status', 'evidence', 'frameworks', 'pci-dss', 'soc2', 'hipaa'],
    relatedPages: ['/controls', '/mappings'],
    icon: 'Shield',
    order: 1,
  }),

  createArticle({
    id: 'uploading-evidence',
    title: 'Uploading Evidence',
    section: 'controls',
    summary: 'Evidence proves control compliance. Upload screenshots, documents, configurations, or link cloud integration data. Evidence has types, expiration dates, and retention policies.',
    content: `
# Uploading Evidence

Evidence is the proof that your controls are implemented and working. The platform supports multiple ways to collect and manage evidence.

## Evidence Types

- **Document** - Policies, procedures, reports
- **Screenshot** - Visual proof of configurations
- **Configuration** - System settings and exports
- **Log** - Audit logs and system logs
- **Certificate** - SSL certificates, compliance certs
- **Other** - Any other supporting documentation

## How to Upload Evidence

### Manual Upload
1. Navigate to the control that needs evidence
2. Click **Upload Evidence**
3. Select the file(s) to upload
4. Choose the evidence type
5. Add a description explaining what the evidence shows
6. Set an expiration date if applicable

### Cloud Integration Evidence
When you connect AWS or Azure, the platform automatically collects:
- IAM policies and configurations
- Security group rules
- Encryption settings
- Compliance reports

This evidence is linked to relevant controls automatically.

## Evidence Management

- **Expiration** - Set dates when evidence needs to be refreshed
- **Retention** - Evidence is retained according to your policy
- **Versioning** - Upload new versions as evidence is updated
- **Tags** - Organize evidence with custom tags
    `.trim(),
    tags: ['evidence', 'upload', 'compliance', 'documentation', 'proof', 'audit'],
    relatedPages: ['/controls', '/evidence'],
    icon: 'Upload',
    order: 2,
  }),
]
